// extracted by mini-css-extract-plugin
module.exports = {"main":"burger-ingredients_main___Nj9R","cards":"burger-ingredients_cards__rdQZ9"};